/**
 * Constantes de la aplicación
 * Evita magic numbers y strings hardcodeados
 */

// Timeouts y delays
export const TIMEOUTS = {
  API_REQUEST: 10000, // 10 segundos
  API_REQUEST_LONG: 30000, // 30 segundos para operaciones largas
  DEBOUNCE_SEARCH: 500, // 500ms para búsquedas
  DEBOUNCE_INPUT: 300, // 300ms para inputs generales
  THROTTLE_SCROLL: 200, // 200ms para scroll
  LOADING_MIN: 300, // Duración mínima de loading para evitar flashes
  TOAST_DURATION: 3000, // 3 segundos para toasts
  TOAST_DURATION_ERROR: 5000, // 5 segundos para errores
} as const

// Roles de usuario
export const USER_ROLES = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  BARBER: 'BARBER',
  CUSTOMER: 'CUSTOMER',
} as const

// Estados de citas
// Appointment Status - debe coincidir con api/src/types/appointmentStatus.ts
export const APPOINTMENT_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const

type AppointmentStatus = typeof APPOINTMENT_STATUS[keyof typeof APPOINTMENT_STATUS]

